// T-NOTIF-012 (WebUI #226): the only gate between a server-supplied
// `notification.url` and a navigation. Accepts a same-origin application path
// and returns it normalised (pathname + search + hash); returns null for
// everything else (javascript:, data:, https://other, protocol-relative
// //host, /\host, control-character smuggling, non-strings).
//
// Browsers strip tab/CR/LF anywhere in a URL and treat "\" as "/" in special
// schemes, so "/\t/evil" and "/\evil" are really "//evil". The raw value must
// therefore be rejected before any parsing, not after.
const CONTROL_OR_BACKSLASH = /[\u0000-\u001f\u007f\\]/;

export const resolveSafeAppPath = (rawUrl, origin = window.location.origin) => {
  if (typeof rawUrl !== 'string') return null;
  if (rawUrl.length === 0 || rawUrl[0] !== '/') return null;
  if (rawUrl[1] === '/') return null;
  if (CONTROL_OR_BACKSLASH.test(rawUrl)) return null;

  let parsed;
  try {
    parsed = new URL(rawUrl, origin);
  } catch (err) {
    return null;
  }
  if (parsed.origin !== origin) return null;
  if (parsed.pathname.startsWith('//')) return null;
  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
};
